import styled from "styled-components";
import Img from "../../Img";

export const Wrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  cursor: pointer;
  @media (max-height: 800px) {
    width: 50px;
    height: 50px;
  }
`;

export const Image = styled(Img)`
  display: flex;
  width: 100%;
  height: 100%;
`;
